import type { AIJob } from "@vida/currents-core";
import { apiFetch } from "../api";

/** URL presigned per anteprima immagine (outputAssetKey). */
export async function resolveJobOutputImageUrl(jobId: string): Promise<string | null> {
  try {
    const signed = await apiFetch<{ url: string }>(`/api/jobs/${jobId}/output-url`);
    return signed.url?.trim() || null;
  } catch {
    return null;
  }
}

/** Risolve il testo finale del job (inline o da S3 via admin-api). */
export async function resolveJobOutputText(job: AIJob): Promise<string | null> {
  if (job.providerUsageJson) {
    try {
      const usage = JSON.parse(job.providerUsageJson) as {
        outputText?: string;
        outputInS3?: boolean;
      };
      if (usage.outputText?.trim()) {
        return usage.outputText.trim();
      }
    } catch {
      /* fall through */
    }
  }

  if (!job.outputAssetKey) return null;

  try {
    const signed = await apiFetch<{ url: string }>(`/api/jobs/${job.jobId}/output-url`);
    if (!signed.url) return null;
    const res = await fetch(signed.url);
    if (!res.ok) return null;
    const body = await res.text();
    try {
      const parsed = JSON.parse(body) as unknown;
      if (typeof parsed === "string") return parsed;
      return JSON.stringify(parsed, null, 2);
    } catch {
      return body.trim() || null;
    }
  } catch {
    return null;
  }
}
